import styles from './index.less';
import $ from 'jquery';
import Modal from '../modal';

const defaultPrams = {
  src: '',
};
export default class IframeModal extends Modal {
  constructor(props) {
    super(props);
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this._initContent();
  }
  _initContent() {
    const params = this.params;
    this.$iframe = $(
      `<div class="${styles['iframe-wrapper']}">
        <iframe 
          src="${params.src}" >
        />
      </div>`,
    );
    this.$dom.append(this.$iframe);
  }
}
